import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { TextField, Grid, FormControl, MenuItem, InputLabel, Select, Chip } from '@mui/material';
import { notify } from '../../common/functions/react-toastify.function';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import apiClient from '../../common/functions/api_axios_instance.function';
import UploadIcon from '../../Assets/AlertIcon/uploadIcon.svg';
import { getCompanies } from '../UserManagement/userManagementFunctions/get_companies.function';
import { useSetAtom, useAtom, useAtomValue } from 'jotai';
import {
  openUploadKmz,
  kmzUploadResponse,
  selectedKmz,
  regionsKmz,
  citiesKmz,
  kmzNetwork,
} from '../../common/atom/atoms';
import { KMZ_UPLOAD, UPDATE_KMZ } from '../../common/constants/constants';
import { logout } from '../../common/functions/log_out.function';
import { getRegionsForUpload } from './functions/get_regions.function';
import { getCitiesForUpload } from './functions/get_upload_cities.function';
import { Autocomplete } from '@mui/material';
import { handleApiError } from '../../common/functions/errorHandler.function';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '5px',
  p: 4,
};

export default function UploadKmzModal(props) {
  const { getAllKmz } = props;
  const [open, setOpen] = useAtom(openUploadKmz);
  const kmzNetworkValue = useAtomValue(kmzNetwork);

  const setUploadResponse = useSetAtom(kmzUploadResponse);
  const [selectedKmzs, setSelectedKmz] = useAtom(selectedKmz);
  console.log('selectedKmzs', selectedKmzs);
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const kmzObjectTemplate = {
    file: '',
    name: '',
    partner: '',
    network: '',
    regions: [],
    cities: [],
  };
  const [kmzObj, setKmzObj] = useState(kmzObjectTemplate);
  const [errors, setErrors] = useState({});
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);

  const validateForm = () => {
    let newErrors = {};
    if (!kmzObj.file) {
      newErrors.file = 'Please upload a KMZ file.';
    }
    if (!kmzObj.name) {
      newErrors.name = 'Name is required.';
    }
    if (!kmzObj.partner) {
      newErrors.partner = 'Partner is required.';
    }
    if (!kmzObj.network) {
      newErrors.network = 'Network is required.';
    }
    if (!kmzObj.regions.length) {
      newErrors.regions = 'Regions are required.';
    }
    if (!kmzObj.cities.length) {
      newErrors.cities = 'City is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (selectedKmzs) {
      setKmzObj({
        file: selectedKmzs.fileName,
        name: selectedKmzs.name,
        partner: selectedKmzs.partner,
        network: selectedKmzs.network,
        regions: selectedKmzs.regions,
        cities: selectedKmzs.cities,
      });
    } else {
      setKmzObj(kmzObjectTemplate);
    }
  }, [selectedKmzs]);
  useEffect(() => {
    if (!kmzObj?.network) {
      return;
    }
    getRegions();
  }, [kmzObj.network]);
  useEffect(() => {
    getCities();
  }, [kmzObj.regions]);
  const getRegions = async () => {
    try {
      const resp = await getRegionsForUpload(kmzObj.network);
      setRegions(resp?.response);
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };
  const getCities = async () => {
    try {
      const regionParams = kmzObj.regions.map((r) => `${r}`).join(',');
      const resp = await getCitiesForUpload(kmzObj.network, regionParams);
      setCities(resp?.response);
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'network') {
      setKmzObj((prevState) => ({
        ...prevState,
        regions: [],
        cities: [],
      }));
    }
    if (name === 'regions') {
      setKmzObj((prevState) => ({
        ...prevState,
        cities: [],
      }));
    }
    setKmzObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCloseModal = () => {
    setKmzObj(kmzObjectTemplate);
    setErrors({});
    setSelectedKmz(null);
    setOpen(false);
  };

  const handleUpdate = async () => {
    showBackdrop();
    try {
      const formData = new FormData();
      formData.append('partner', kmzObj?.partner);
      formData.append('network', kmzObj?.network);
      formData.append('regions', kmzObj?.regions);
      formData.append('cities', kmzObj?.cities);

      if (kmzObj?.file) {
        formData.append('file', kmzObj.file);
      }

      const response = await apiClient.put(UPDATE_KMZ(kmzObj.name), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response) {
        handleCloseModal();
        getAllKmz();
        notify('success', response.data.message);
      }
    } catch (err) {
      hideBackdrop();
      handleApiError(err);
    }
    hideBackdrop();
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      notify('error', 'Please fill all required fields.');
      return;
    }
    showBackdrop();
    try {
      const formData = new FormData();
      Object.keys(kmzObj).forEach((key) => {
        formData.append(key, kmzObj[key]);
      });
      const response = await apiClient.post(KMZ_UPLOAD, formData);
      if (response) {
        setUploadResponse(response.data.response);
        notify('success', 'KMZ Upload Successfully');
        handleCloseModal();
        getAllKmz();
      }
    } catch (err) {
      handleApiError(err);
    }
    hideBackdrop();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith('.kmz')) {
      setKmzObj((prev) => ({ ...prev, file }));
      setErrors((prev) => ({ ...prev, file: '' }));
    } else {
      notify('error', 'Please upload a valid KMZ file.');
      setKmzObj((prev) => ({ ...prev, file: '' }));
      setErrors((prev) => ({ ...prev, file: 'Invalid file format.' }));
    }
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          handleCloseModal();
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography
                id="modal-modal-title"
                style={{
                  fontSize: '24px',
                  fontWeight: 500,
                }}
              >
                {selectedKmzs ? 'Update Kmz' : 'Add Kmz File'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} paddingTop={'20px'}>
            <Grid item xs={6}>
              <TextField
                label="Name"
                variant="outlined"
                sx={{ width: '100%' }}
                name="name"
                value={kmzObj.name}
                disabled={selectedKmzs?.name ? true : false}
                onChange={handleChange}
                required
                error={!!errors.name}
                helperText={errors.name}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Partner</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={kmzObj.partner}
                  label="Partner"
                  name="partner"
                  onChange={handleChange}
                  // size='small'
                  required
                  error={!!errors.partner}
                  helperText={errors.partner}
                >
                  <MenuItem value={''} disabled>
                    Please Select
                  </MenuItem>
                  <MenuItem value={'zong'}>zong</MenuItem>
                  <MenuItem value={'Zong'}>Zong</MenuItem>
                  <MenuItem value={'cybernet'}>Cybernet</MenuItem>
                  <MenuItem value={'multinet'}>Multinet</MenuItem>
                  <MenuItem value={'wateen'}>Wateen</MenuItem>
                  <MenuItem value={'optix'}>Optix</MenuItem>
                  <MenuItem value={'ptcl'}>Ptcl</MenuItem>
                  <MenuItem value={'ufone'}>Ufone</MenuItem>
                  <MenuItem value={'jazz'}>Jazz</MenuItem>
                  <MenuItem value={'telenor'}>Telenor</MenuItem>
                  <MenuItem value={'nayatel'}>Nayatel</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2} paddingTop={'20px'}>
            <Grid item xs={6}>
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <InputLabel id="demo-simple-select-company">Network</InputLabel>
                <Select
                  labelId="demo-simple-select-company"
                  id="demo-simple-select"
                  name="network"
                  value={kmzObj.network}
                  onChange={handleChange}
                  disabled={selectedKmzs?.fileName ? true : false}
                  sx={{ width: '100%' }}
                  size="large"
                  label="Network"
                  data-testId="userModal-company-1"
                  error={!!errors.network}
                  helperText={errors.network}
                  required
                >
                  <MenuItem value="" disabled>
                    <em>Please Select</em>
                  </MenuItem>
                  <MenuItem value="FTTS">FTTS</MenuItem>
                  <MenuItem value="MPBN">MPBN</MenuItem>
                  <MenuItem value="OTN">OTN</MenuItem>
                  <MenuItem value="IPRAN">IPRAN</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Region</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  multiple // Enable multi-select
                  value={kmzObj.regions || []} // Ensure value is an array
                  label="Region"
                  error={!!errors.regions}
                  helperText={errors.regions}
                  onChange={handleChange}
                  name="regions"
                  renderValue={(selected) => selected.join(', ')} // Display selected values as a comma-separated string
                >
                  <MenuItem value={''} disabled>
                    Please Select
                  </MenuItem>
                  {regions?.map((reg) => (
                    <MenuItem value={reg.region}>{reg.region}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} paddingTop={'20px'}>
            <Grid item xs={12}>
              {/* <FormControl variant="outlined" sx={{ width: '100%' }}>
                                <InputLabel>City</InputLabel>
                                <Select
                                    name="cities"
                                    multiple // Enable multi-select
                                    value={kmzObj?.cities || []} // Ensure value is an array
                                    onChange={handleChange}
                                    sx={{ width: '100%' }}
                                    label='City' // Update label to match the field
                                    data-testId='userModal-department-1'
                                    error={!!errors.cities}
                                    helperText={errors.cities}
                                    required
                                    renderValue={(selected) => {
                                        const maxToShow = 4; // Show only 3 cities
                                        const extraCount = selected.length - maxToShow;

                                        return (
                                            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 0.5, overflow: 'hidden' }}>
                                                {selected.slice(0, maxToShow).map((value) => (
                                                    <Chip key={value} label={value} size="small" />
                                                ))}
                                                {extraCount > 0 && (
                                                    <Chip label={`+${extraCount} more`} size="small" />
                                                )}
                                            </Box>
                                        );
                                    }}
                                 >
                                    <MenuItem value="" disabled>
                                        <em>Please Select</em>
                                    </MenuItem>
                                    {cities?.map((ct) =>
                                        <MenuItem value={ct.city}>{ct.city}</MenuItem>
                                    )}
                                </Select>
                            </FormControl> */}

              <Autocomplete
                multiple
                options={cities || []}
                getOptionLabel={(option) => option.city}
                value={kmzObj?.cities?.map((city) => ({ city })) || []}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: 'cities',
                      value: newValue.map((item) => item.city),
                    },
                  });
                }}
                filterSelectedOptions
                renderTags={(value, getTagProps) => {
                  const maxToShow = 4;
                  const extraCount = value.length - maxToShow;

                  return (
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 0.5, overflow: 'hidden' }}>
                      {value.slice(0, maxToShow).map((option, index) => (
                        <Chip label={option.city} size="small" {...getTagProps({ index })} />
                      ))}
                      {extraCount > 0 && <Chip label={`+${extraCount} more`} size="small" />}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="City"
                    variant="outlined"
                    error={!!errors.cities}
                    helperText={errors.cities}
                    required
                    data-testId="userModal-department-1"
                  />
                )}
                sx={{ width: '100%' }}
              />
            </Grid>
          </Grid>
          <div
            onClick={() => document.getElementById('kmz-upload').click()}
            style={{
              cursor: 'pointer',
              width: 656,
              height: 90,
              padding: '21px 0',
              marginTop: '4%',
              background: 'rgba(189, 29, 35, 0.01)',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
              borderRadius: 4,
              border: '2px dotted #C8CCD2',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <input
              type="file"
              id="kmz-upload"
              accept=".kmz"
              style={{ display: 'none' }}
              onChange={handleFileUpload}
            />

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={UploadIcon} alt="Upload" style={{ marginRight: 16 }} />

              <div>
                <div
                  style={{ color: '#656E7A', fontSize: 14, fontFamily: 'Poppins', fontWeight: 500 }}
                >
                  {kmzObj?.file?.name || selectedKmzs?.fileName || 'Upload KMZ File'}
                </div>

                {kmzObj?.file && (
                  <div
                    style={{ color: '#656E7A', fontSize: 12, fontFamily: 'Poppins', marginTop: 4 }}
                  >
                    <strong>Selected File:</strong> {kmzObj.file.name}
                  </div>
                )}
              </div>
            </div>
          </div>

          <Grid container spacing={2} paddingTop={'32px'}>
            <Grid item xs={4}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#BD1D23',
                  width: '100%',
                  '&:hover': {
                    backgroundColor: '#BD1D23', // Ensure the hover color remains the same
                  },
                  '&:disabled': {
                    backgroundColor: '#E57373',
                    color: '#fff',
                  },
                }}
                // disabled={Object.keys(errors).length > 0}
                onClick={selectedKmzs ? handleUpdate : handleSubmit}
                disabled={
                  kmzObj?.cities?.length < 1 ? true : kmzObj?.regions?.length < 1 ? true : false
                }
              >
                {selectedKmzs ? 'Update' : 'Create'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                variant="contained"
                sx={{
                  color: '#000',
                  backgroundColor: 'white',
                  width: '100%',
                  '&:hover': {
                    borderColor: '#BD1D23',
                    backgroundColor: 'rgba(189, 29, 35, 0.1)',
                  },
                }}
                onClick={handleCloseModal}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
